<div class="column full-width full-height">
    <p-dropdown [appendTo]="null" [options]="spinnersCategories" [(ngModel)]="selectedCategory" optionLabel="Description"
        optionValue="Id">
    </p-dropdown>
    <div class="ui-g container">
        <button *ngFor="let spinner of currentSpinners" class="design-setting-item"
            [ngClass]="{'selected-spinner': spinner.Id===selectedSpinnerId}" (click)="selectSpinner(spinner)">
            <img [src]="spinner.ThumbUrl" alt="Image" pTooltip="{{spinner.Description}}" />
            <span class="img-title">{{spinner.SpinnerName}}</span>
        </button>
    </div>
</div>